import React from "react";

export interface RevenueVsExpensesInsightsProps {
  title: string;
  body: string;
  sentiment?: "neutral" | "positive" | "negative";
}

const sentimentLabel = {
  neutral: "Neutral",
  positive: "Positive",
  negative: "Negative",
};

export function RevenueVsExpensesInsights({
  title,
  body,
  sentiment = "neutral",
}: RevenueVsExpensesInsightsProps) {
  const isPositive = sentiment === "positive";
  const isNegative = sentiment === "negative";
  const containerClass = isPositive
    ? "border-success-500 bg-success-50"
    : isNegative
      ? "border-error-500 bg-error-50"
      : "border-neutral-300 bg-neutral-50";
  const dotClass = isPositive
    ? "bg-success-500"
    : isNegative
      ? "bg-error-500"
      : "bg-neutral-400";
  const labelClass = isPositive
    ? "text-success-600"
    : isNegative
      ? "text-error-600"
      : "text-neutral-500";

  return (
    <div
      className={`flex w-full max-w-sm flex-none flex-col items-start gap-4 rounded-r-lg border-l-4 border-solid px-4 py-6 sm:px-6 min-w-0 ${containerClass}`}
    >
      <span className="text-heading-3 font-heading-3 text-neutral-900">
        {title}
      </span>
      <span className="text-body font-body text-neutral-600">{body}</span>
      <div className="flex items-center gap-2 mt-auto">
        {/* <div
          className={`flex h-2 w-2 flex-none flex-col items-start rounded-full ${dotClass}`}
        /> */}
        {/* <span
          className={`text-caption-bold font-caption-bold uppercase ${labelClass}`}
        >
          {sentimentLabel[sentiment]}
        </span> */}
      </div>
    </div>
  );
}
